import { apiV1 } from "../lib/axios";
import { toast } from "react-toastify";
import { getApiErrorMessage } from "../utils/getApiErrorMessage";

export const sendTransactionMfa = async () => {
  await apiV1.post("/mfa")
      .catch((err) => {
        toast.error(getApiErrorMessage(err, "Erro ao enviar o MFA"));
        return;
      });
    return
}

export const sendNewAccountMfa = async (phoneNumber) => {
  try {
    const response = await apiV1.post("/send-phone-mfa-new-account", { phoneNumber })
    return response.data

  } catch (err) {
    toast.error(getApiErrorMessage(err, "Erro ao enviar o MFA"));
    return;
  }
}

export const mfaNewAccountVerify = async (phoneNumber, otp) => {
  try {
    const response = await apiV1.post("/validate-phone-mfa-new-account", { phoneNumber, otp })
    return response.data
  } catch (err) {
    toast.error(getApiErrorMessage(err, "Erro ao validar o código OTP"));
    return;
  }
}
